import * as React from 'react';
import SimpleBar from 'simplebar-react';
import * as PropTypes from "prop-types";

export default function ThemesScrollbar({children, maxHeight}) {
  return (
    <SimpleBar
      className={"themed-scrollbar"}
      autoHide={false}
      style={{maxHeight}}
    >
      {children}
    </SimpleBar>
  )
}

ThemesScrollbar.propTypes = {
  children: PropTypes.node,
  maxHeight: PropTypes.string
};